export class SiteModel {
    QueryValue: string;
    SiteId: string;
    SiteName: string;
    Address: string;
    Active: number;
    Company: string;
    Action: string;

    constructor() {
        this.QueryValue = '';
        this.SiteId = '';
        this.SiteName = '';
        this.Address = '';
        this.Active = 0;
        this.Company = '';
        this.Action = '';

    }
  }
